import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation toggleClientOrganizationActivation($id: String!) {
    toggleClientOrganizationActivation(id: $id) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const toggleClientOrganizationActivationRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/toggle_client_organization_activation',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.toggleClientOrganizationActivation;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const toggleClientOrganizationActivationSlice = createSlice({
  name: 'toggle_client_organization_activation',
  initialState: initialState,
  reducers: {
    toggleClientOrganizationActivationClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(toggleClientOrganizationActivationRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      toggleClientOrganizationActivationRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(
      toggleClientOrganizationActivationRequest.rejected,
      (state, action) => {
        state.error = action.payload as Error || {
          message: 'Failed to fetch',
          statusCode: '500'
        };
        state.loading = false;
      }
    );
  }
});

export const { toggleClientOrganizationActivationClear } =
toggleClientOrganizationActivationSlice.actions;

export const toggleClientOrganizationActivation = createSelector(
  (state: RootState) =>
  state.organization.toggleClientOrganizationActivation.result,
  (state: RootState) =>
  state.organization.toggleClientOrganizationActivation.error,
  (state: RootState) =>
  state.organization.toggleClientOrganizationActivation.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default toggleClientOrganizationActivationSlice.reducer;